// extracted by mini-css-extract-plugin
export default {"listRowInquiries":"companyInquiries_listRowInquiries__aa5dk"};